module.exports = __webpack_public_path__ + "static/media/turing.e7e33288.gif";